(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('VideoType', VideoType);

    VideoType.$inject = ['$resource'];

    function VideoType ($resource) {
        var resourceUrl =  'api/video-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
